import { render, staticRenderFns } from "./like.vue?vue&type=template&id=72f537a0&"
import script from "./like.vue?vue&type=script&lang=js&"
export * from "./like.vue?vue&type=script&lang=js&"
import style0 from "./like.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports